import InputFileUpload from "./inputFileUpload";

export default InputFileUpload;